import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const EquivalenciaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='EQUIVALENCIA' htmlFor='select-equivalencia' xs={4} alignRightAt='xs' />
      <Col xs={8}>
        <Field name='equivalencia'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-equivalencia'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(EquivalenciaFormGroup)
